// theme.js
import { extendTheme, useColorModeValue } from '@chakra-ui/react';

import { closeButtonTheme } from '../components/widgets/CloseButton';

const theme = extendTheme({
  initialColorMode: 'dark', // Impostato su 'light' per testi neri
  colors: {
    brand: {
      100: '#ffcc00', // Giallo
      200: '#3eb297', // Verde acqua
      300: '#36a9e1', // Blu
      400: '#e95995', // Rosa
      500: '#3b235a', // Viola scuro
      600: '#e73341', // Rosso
      900: '#1a202c', // Default scuro
      // Rimuoviamo gli altri colori per limitare la palette
    },
    yellow: {
      50: '#fff5cc', // Giallo molto chiaro
      100: '#ffeb99', // Giallo pastello
      200: '#ffe066', // Giallo chiaro
      300: '#ffd633', // Giallo più vivido
      400: '#ffcc00', // Giallo principale
      500: '#e6b800', // Giallo leggermente scuro
      600: '#cc9900', // Giallo ocra
      700: '#b37a00', // Giallo bruno
      800: '#a18100', // Giallo senape
      900: '#805500', // Giallo scuro/marrone
    },
  },
  components: {
    CloseButton: closeButtonTheme,
  },
});

export const useSectionBgGradient = () => {
  const bgGradient = useColorModeValue(
    'linear(to-b, teal.50, white)',
    'linear(to-b, gray.700, gray.800)'
  );

  return bgGradient;
};

export default theme;
